import request from '@/utils/request'

// ========== 小区体验申请 ==========
// 查询小区体验申请列表
export function listCommunityExperienceApplys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listCommunityExperienceApplys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取小区体验申请列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 提交小区体验申请
export function saveCommunityExperienceApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.saveCommunityExperienceApply',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '提交申请失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核小区体验申请
export function auditCommunityExperienceApply(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.newAuditCommunityExperienceApply',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核操作失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 面积反馈 ==========
// 获取面积反馈列表
export function listAreaFeedback(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaFeedback.listAreaFeedback',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取面积反馈列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核面积反馈（同意/驳回）
export function auditAreaFeedback(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/areaFeedback.auditAreaFeedback',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核操作失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 小区反馈 ==========
// 查询小区反馈列表
export function listCommunityFeedbacks(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listCommunityFeedbacks',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取小区反馈列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存小区反馈
export function saveCommunityFeedback(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.saveCommunityFeedback',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '提交反馈失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核小区反馈
export function approveCommunityFeedback(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.approveCommunityFeedback',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 认证管理 ==========
// 获取认证管理列表
export function listAuthManagement(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.listAdminAppUserOwners',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.success) {
        const list = Array.isArray(res.data) ? res.data : (Array.isArray(res.records) ? res.records : [])
        const total = res.total || res.totalCount || res.count || list.length
        resolve({ records: list, total })
      } else if (Array.isArray(res.data || res.records)) {
        const list = res.data || res.records
        resolve({ records: list, total: res.total || list.length })
      } else if (Array.isArray(res)) {
        resolve({ records: res, total: res.length })
      } else {
        reject(new Error(res.msg || '获取认证管理列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核人员认证（同意/驳回）
export function auditAuthOwner(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.auditAuthOwner',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核操作失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 获取房屋审核列表
export function listAuthOwnerRooms(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.listAuthOwnerRooms',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.success) {
        const list = Array.isArray(res.data) ? res.data : []
        const total = res.records || res.total || list.length
        resolve({ records: list, total })
      } else if (Array.isArray(res.data)) {
        resolve({ records: res.data, total: res.records || res.total || res.data.length })
      } else {
        reject(new Error(res.msg || '获取房屋审核列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核房屋认证（同意/驳回）
export function auditAuthOwnerRoom(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/owner.auditAuthOwnerRoom',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核操作失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 资料管理 ==========
// 获取资料管理列表
export function listDataManagement(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dataManagement.listDataManagement',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取资料管理列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核资料（同意/驳回）
export function auditDataManagement(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/dataManagement.auditDataManagement',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核操作失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 富文本 ==========
// 获取富文本列表
export function listRichText(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.listRichText',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取富文本列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存富文本（新增/编辑）
export function saveRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.saveRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新富文本
export function updateRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.updateRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除富文本
export function deleteRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.deleteRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 回收站列表
export function listRecycleRichText(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.listRecycleRichText',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取回收站列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 还原富文本
export function restoreRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.restoreRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '还原失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 回收站一键还原
export function batchRestoreRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.batchRestoreRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '一键还原失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 移除富文本（永久删除）
export function removeRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.removeRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '移除失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 清空回收站
export function cleanRecycleRichText(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/richText.cleanRecycleRichText',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '清空回收站失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 附件管理 ==========
// 获取附件管理列表
export function listAttachmentManage(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attachmentManage.listAttachmentManage',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取附件管理列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存附件（新增/编辑）
export function saveAttachmentManage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/app/attachmentManage.saveAttachmentManage',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除附件
export function deleteAttachmentManage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/attachmentManage.deleteAttachmentManage',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 幻灯片 ==========
// 获取幻灯片列表
export function listSlideshow(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/slide.listSlide',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取幻灯片列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存幻灯片
export function saveSlideshow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/slide.saveSlide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新幻灯片
export function updateSlideshow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/slide.updateSlide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 上传幻灯片图片
export function uploadSlideshowImage(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/callComponent/upload/uploadFile/uploadImage',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      // 兼容标准 code/msg/data 结构，也兼容直接返回 url/fileId 的上传接口
      if (res && (res.url || res.fileId || res.fileUrl || res.path)) {
        resolve(res)
      } else if (res.code == 0) {
        resolve(res.data || res)
      } else {
        reject(new Error(res.msg || '上传失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除幻灯片
export function deleteSlideshow(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/slide.deleteSlide',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 用户管理 ==========
// 获取用户管理列表
export function listUserManagement(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.listUsers',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      // 兼容多种响应格式：直接数组 / {code:0, data:...} / {users:[...], total:N}
      if (Array.isArray(res)) {
        resolve(res)
      } else if (res.code == 0 || res.code == 200) {
        resolve(res)
      } else if (Array.isArray(res.users) || Array.isArray(res.data) || Array.isArray(res.records)) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取用户管理列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 编辑用户
export function updateUserManagement(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.saveUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.code === 0 || res.code === 200) {
        resolve(res)
      } else if (res.userId || res.msg === 'success' || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '编辑用户失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 新增用户
export function addUserManagement(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.saveUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.code === 0 || res.code === 200) {
        resolve(res)
      } else if (res.userId || res.msg === 'success' || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '新增用户失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除用户
export function deleteUserManagement(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/user.deleteSystemUser',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.code === 0 || res.code === 200) {
        resolve(res)
      } else if (res.msg === 'success' || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '删除用户失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 区住建局人员区县范围（文档7.7/7.8） ==========
// 配置人员区县范围（文档7.7）
export function updateHousingBureauStaffScope(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housingBureauStaff.updateHousingBureauStaffScope',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.code === 0 || res.code === 200) {
        resolve(res)
      } else if (res.msg === 'success' || res.success) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '配置人员区县范围失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询人员区县范围（文档7.8）
export function listHousingBureauStaffScopes(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/housingBureauStaff.listHousingBureauStaffScopes',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0 || res.code == 200 || res.code === 0 || res.code === 200) {
        resolve(res)
      } else if (Array.isArray(res.data) || Array.isArray(res)) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '查询人员区县范围失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 投票延期审核 ==========
// 查询投票延期申请列表
export function listVoteDelayApplies(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/vote.listVoteDelayApplies',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '获取投票延期申请列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 审核通过投票延期申请
export function approveVoteDelay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/vote.approveVoteDelay',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '审核通过失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 驳回投票延期申请
export function rejectVoteDelay(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/vote.rejectVoteDelay',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '驳回失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// ========== 角色组 ==========
// 获取角色组列表
export function listRoleGroups(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.store.privilegeGroup',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      // 接口直接返回数组，不是 { code: 0, data: [...] } 结构
      if (Array.isArray(res)) {
        resolve(res)
      } else if (res.code == 0) {
        resolve(res.data || res.records || res)
      } else {
        reject(new Error(res.msg || '获取角色组列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}
